export default __webpack_public_path__ + "maps-examples-custom-style-960-cc48f95913e91396aa34bf5d3d281bcd.png";